"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_33)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_33`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#009B3A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9999 1.3544L26.3789 11.979L11.9999 22.5965L-2.44922 11.979L11.9999 1.3544Z",
					fill: "#FEDF00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 17.6421C15.1161 17.6421 17.6421 15.116 17.6421 12C17.6421 8.88394 15.1161 6.35788 12 6.35788C8.88397 6.35788 6.35791 8.88394 6.35791 12C6.35791 15.116 8.88397 17.6421 12 17.6421Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.15095 11.6281C8.17551 11.6281 7.22814 11.7754 6.33691 12.0491C6.37902 15.1298 8.88428 17.614 11.972 17.614C13.8808 17.614 15.572 16.6597 16.5895 15.207C14.8422 13.0316 12.1545 11.6281 9.15095 11.6281ZM17.5018 13.0526C17.565 12.7018 17.6071 12.3439 17.6071 11.9719C17.6071 8.85615 15.0808 6.32983 11.965 6.32983C9.64218 6.32983 7.64919 7.74036 6.77902 9.74036C7.54393 9.58597 8.3299 9.50176 9.13691 9.50176C12.4211 9.50878 15.3825 10.8702 17.5018 13.0526Z",
					fill: "#002776"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_33`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BRFlag };
